import React from "react";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import Heading from "../../../../../component-lib/Atoms/heading/EventEHRHeading";
import { TEXT_CONSTANTS } from "../../../../../utils/text-constants/textConstants";
import useDeviceType from "../../../../../custom-hooks/DeviceType";
import Input from "../../../../../component-lib/Atoms/Input/Input";
import Button from "../../../../../component-lib/Molecules/button/Button";
import { EDIT_CHIEF_COMPLAINT_DETAILS, lABEL_STYLE } from "./constants";

interface ChiefComplaintProps {
  defaultSelectedData?: string;
  getFormData: (data: any) => void;
  handleClose: () => void;
}

export default function EditChiefComplaint({
  defaultSelectedData,
  getFormData,
  handleClose,
}: ChiefComplaintProps) {
  const deviceType = useDeviceType();

  const validationSchema = Yup.object().shape({
    [EDIT_CHIEF_COMPLAINT_DETAILS?.CHIEF_COMPLAINT]: Yup.string().required(
      "Chief Complaint is required"
    ),
  });

  return (
    <Formik
      initialValues={{
        [EDIT_CHIEF_COMPLAINT_DETAILS?.CHIEF_COMPLAINT]: defaultSelectedData,
      }}
      validationSchema={validationSchema}
      enableReinitialize
      onSubmit={(values, { setSubmitting }) => {
        try {
          getFormData(values);
        } catch (error) {
          console.log(error);
        } finally {
          setSubmitting(false); // Reset submitting state
        }
      }}
    >
      {({
        errors,
        values,
        touched,
        isValid,
        dirty,
        setFieldValue,
        handleBlur,
        handleSubmit,
      }) => {
        return (
          <Form onSubmit={handleSubmit}>
            <div
              className="h-full flex flex-col justify-between gap-6"
              style={{
                height: deviceType === "mobile" ? "40vh" : "fit-content",
                overflow: "auto",
              }}
            >
              {/* NOTES */}
              <div>
                <Heading
                  title={TEXT_CONSTANTS?.CHIEF_COMPLAINT}
                  customStyle={lABEL_STYLE}
                />
                <Input
                  maxWords={250}
                  multiline={true}
                  rows={2}
                  // textFieldLabel="Enter Chief Complaint"
                  placeholder={TEXT_CONSTANTS?.ENTER_CHIEF_COMPLAINT}
                  name={EDIT_CHIEF_COMPLAINT_DETAILS.CHIEF_COMPLAINT}
                  value={values[EDIT_CHIEF_COMPLAINT_DETAILS.CHIEF_COMPLAINT]}
                  onChangeCb={(e) => {
                    setFieldValue(
                      EDIT_CHIEF_COMPLAINT_DETAILS.CHIEF_COMPLAINT,
                      e.target.value
                    );
                  }}
                  onBlur={handleBlur}
                  size="small"
                  error={
                    touched[EDIT_CHIEF_COMPLAINT_DETAILS.CHIEF_COMPLAINT] &&
                    Boolean(
                      errors[EDIT_CHIEF_COMPLAINT_DETAILS.CHIEF_COMPLAINT]
                    )
                  }
                  helperText={
                    touched[EDIT_CHIEF_COMPLAINT_DETAILS.CHIEF_COMPLAINT]
                      ? errors[EDIT_CHIEF_COMPLAINT_DETAILS.CHIEF_COMPLAINT]
                      : undefined
                  }
                />
              </div>
            </div>

            <div className="flex justify-end mt-10 gap-4">
              <Button
                label={TEXT_CONSTANTS?.CANCEL}
                variant="outlined"
                onClickCb={() => {
                  handleClose();
                }}
                style={{
                  width: "120px",
                  height: "44px",
                  padding: "12px 20px",
                  fontSize: "16px",
                  backgroundColor: "white",
                  border: "none",
                  color: "#393939",
                }}
              />
              <Button
                // disabled={!isValid} // Button disabled if form is invalid or submitting
                type="submit"
                label={TEXT_CONSTANTS?.SAVE}
                variant="contained"
                onClickCb={() => {}}
                style={{
                  width: "120px",
                  height: "44px",
                  padding: "12px 20px",
                  fontSize: "16px",
                }}
              ></Button>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
}
